/** 动画渲染器 */
var AnimationRenderer = /** @class */ (function () {
    function AnimationRenderer(stageSize) {
        this.stageSize = stageSize || [1920, 1080];
    }
    /** 为弹幕DOM元素添加含动画属性的style标签 */
    AnimationRenderer.prototype.addAnimation = function (dan, container) {
        var style = this.getStyleSheet(dan);
        container.appendChild(style);
    };
    /** 生成css动画的style标签 */
    AnimationRenderer.prototype.getStyleSheet = function (dan) {
        var _this = this;
        var _a;
        var danmaku = dan.danmaku;
        var stylesheet = document.createElement("style");
        var aniId = "danmaku-A-" + dan.rid;
        var position = danmaku.position || [0, 0, 0];
        var rotation = danmaku.rotation || [0, 0, 0];
        var scale = danmaku.scale || [1, 1];
        // 添加初始属性
        stylesheet.innerText += ".pos-danmaku-item-".concat(dan.rid, " { transform: ").concat(this.getCssTransform(position, rotation, scale), " }");
        // 添加css动画帧属性
        (_a = danmaku.animations) === null || _a === void 0 ? void 0 : _a.forEach(function (k, i) {
            if (k.position)
                position = k.position;
            if (k.rotation)
                rotation = k.rotation;
            if (k.scale)
                scale = k.scale;
            stylesheet.innerText += "@keyframes ".concat(aniId, "-").concat(i + 1, " { to { transform: ").concat(_this.getCssTransform(position, rotation, scale), " } }");
        });
        // 添加一个空的停留帧
        stylesheet.innerText += "@keyframes ".concat(aniId, "-E { }");
        // 添加动画属性
        stylesheet.innerText += ".pos-danmaku-item-".concat(dan.rid, " { animation: ").concat(this.getCssAnimation(dan), "; animation-delay: ").concat(this.getCssAnimationDelay(dan.danmaku), "; animation-fill-mode: forwards; }");
        return stylesheet;
    };
    /** 获取transform属性值 */
    AnimationRenderer.prototype.getCssTransform = function (position, rotation, scale) {
        var css_translate = "translate3d(".concat(position[0] * this.stageSize[0], "px, ").concat(position[1] * this.stageSize[1], "px, 0)");
        var css_rotateX = "rotateX(".concat(rotation[0], "deg)");
        var css_rotateY = "rotateY(".concat(rotation[1], "deg)");
        var css_rotateZ = "rotateZ(".concat(rotation[2], "deg)");
        var css_scale = "scale(".concat(scale[0], ", ").concat(scale[1], ")");
        return "".concat(css_translate, " ").concat(css_rotateX, " ").concat(css_rotateY, " ").concat(css_rotateZ, " ").concat(css_scale);
    };
    /** 获取animation属性值 */
    AnimationRenderer.prototype.getCssAnimation = function (dan) {
        var _a;
        var animationLine = [];
        // 根据动画帧添加动画属性
        (_a = dan.danmaku.animations) === null || _a === void 0 ? void 0 : _a.forEach(function (k, i) {
            animationLine.push("danmaku-A-".concat(dan.rid, "-").concat(i + 1, " ").concat(k.duration || 0, "ms ").concat(["linear", "ease-in", "ease-out", "ease-in-out"][k.ease || 0]));
        });
        // 添加停留动画属性
        animationLine.push("danmaku-A-".concat(dan.rid, "-E ").concat(dan.danmaku.duration || 0, "ms linear"));
        return animationLine.join(", ");
    };
    /** 获取animation-delay属性值 */
    AnimationRenderer.prototype.getCssAnimationDelay = function (danmaku, offset // 延迟时间
    ) {
        var _a;
        if (offset === void 0) { offset = 0; }
        var delay = 0;
        var delayLine = [];
        // 为每一动画帧设置delay
        (_a = danmaku.animations) === null || _a === void 0 ? void 0 : _a.forEach(function (k) {
            delayLine.push(delay + offset + "ms");
            delay += k.duration || 0;
        });
        // 为停留帧设置delay
        delayLine.push(delay + offset + "ms");
        return delayLine.join(", ");
    };
    return AnimationRenderer;
}());
export { AnimationRenderer };
//# sourceMappingURL=AnimationRenderer.js.map